<template>
  <div class="lookliveStyle">
    <top-component></top-component>
    <div class="contentStyle">
      <div class="contentStyleChild">
        <iframe id="lookLive" allowfullscreen="true" border="0" :src="src"></iframe>
      </div>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>
<!-- 这个页面是主持人页面的直播 -->
<script>
  import { startlive, activitylistSomeDay } from '@/api/VhallLive'
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'
  import Cookies from 'js-cookie'
  export default {
    name: 'LookLive',
    data() {
      return {
        src: 'https://e.vhall.com/room/embed/157695610?vc=eyJpdiI6InNDSWlIcEZNR2RLazh3S2RIUzNyN3c9PSIsInZhbHVlIjoiVkdLVEZRWUJXUmE1dzk3VjRKTTloUjB0YXRuTmE3TkJleU1uY2lWdUpSYz0iLCJtYWMiOiJhZmJhYjNlNDg3NmU1NGQzMzg3ZDU1NTdkNjkyNjA5NDU3YjAxODEyNTgzNGNmOWM0OWRmZWE4N2IxMjY4MjNlIn0%3D',
        dateTime: '',
        arrow: "always", // 当后面没有数据的时候，never：切换箭头就设置消失
        DateItem: []
      }
    },
    components: {
      BottomComponent,
      TopComponent
    },
    mounted() {
      // 调取直播摄像头和麦克风document.getElementById('lookLive')
      var iframeElment = document.getElementById('lookLive')//this.$refs.lookLive
      if (iframeElment) {
        iframeElment.allow = 'microphone;camera;midi;encrypted-media;'
      }
      // 在同一个浏览器打开的话可以直接取cookie
      if (Cookies.get('webinarId')) {
        // console.log(Cookies.get('webinarId'))
        this.apiSend(Cookies.get('webinarId'))
        // 分享给别人的时候，通过截取url获取id
      } else {
        // console.log(window.location.hash.split('/')[2])
        this.apiSend(window.location.hash.split('/')[2])
      }
    },
    filters: {
      filtersState(value) {
        var dateF = value.split(" ")
        return dateF[1]
      }
    },
    methods: {
      // 获取直播的地址
      apiSend(webinar_id) {
        var obj = {
          webinar_id: webinar_id
        }
        startlive(obj).then(response => {
          this.src = response.data
        //   console.log(this.src)
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .lookliveStyle {
    width: 100%;
    height: 100%;
  }

  .contentStyle {
    width: 100%;
    height: 950px;
    background-image: linear-gradient(#CA242F, #850533, #840533);
  }

  .contentStyleChild {
    margin-left: calc(50% - 600px);
    width: 1200px;
  }

  /* 看直播 */

  #lookLive {
    width: 1200px;
    height: 650px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Live-Platform/Look-Live.vue